// Module
var code = "<div class=\"toast-progress\"></div> ";
// Exports
export default code;